import { QuillInstance, QuillStatic } from '../../types'

import { findPauseBlot, findClosestPauseEl, registerPauseBlot } from './blot'
import { PAUSE_MODULE_NAME } from './constants'
import { PauseOptions } from './types'

export const registerPauseModule = (Quill: QuillStatic) => {
  const PauseBlot = registerPauseBlot(Quill)

  class PauseModule {
    constructor(quill: QuillInstance, options: PauseOptions = {}) {
      quill.root.addEventListener('click', (e) => {
        const target = e.target

        if (!target) {
          return
        }

        if (!(target instanceof HTMLElement)) {
          return
        }

        /**
         * 클래스 명 등으로 구분되어 있지 않아서 가장 가깝고, 가장 상위의 엘리멘트를 찾음
         */
        const closestPause = findClosestPauseEl(target)

        if (!closestPause) {
          return
        }

        const foundBlot = findPauseBlot(closestPause)

        if (!foundBlot) {
          return
        }

        if (!(foundBlot instanceof PauseBlot)) {
          return
        }

        /**
         * 클릭 이벤트 전파를 막아서 버튼이 클릭됐을 때 입력 모달이 닫히지 않도록 함
         */
        e.stopPropagation()

        options.onClick?.(closestPause, foundBlot.value().pause)
      })
    }
  }

  Quill.register(`modules/${PAUSE_MODULE_NAME}`, PauseModule, true)

  return PauseModule
}
